module.exports = __webpack_public_path__ + "img/delete-profile-eng.f704fbea.png";